export enum ObjectTypes {
  ADDRESS = 'Address',
  ADDRESSPERSON = 'AddressPerson',
  ADDRESSRELATION = 'AddressRelation',
  COLLABORATOR = 'xmtMeasureTaskCollaborator',
  COMMENT = 'Comment',
  CONTAINERLIBRARY = 'xmtContainerLibrary',
  CONTAINERLIBRARYLEGALOBLIGATION = 'xmtContainerLibraryLegalObligation',
  COUNTRY = 'xmtRiskIssueCountry',
  COUNTRYLIBRARY = 'CountryLibrary',
  CUSTOMERRISKISSUEOBLIGATION = 'xmtRiskIssueCustomerLegalObligation',
  CUSTOMERRISKLEGALOBLIGATION = 'xmtRiskIssueCustomerLegalObligation',
  CUSTOMERCONTAINER = 'xmtCustomerContainer',
  CUSTOMERCONTAINERLEGALOBLIGATION = 'xmtCustomerContainerLegalObligation',
  CUSTOMERLEGAL = 'xmtCustomerLegal',
  CUSTOMERLEGALDOMAIN = 'xmtCustomerLegalDomain',
  CUSTOMERLEGALOBLIGATION = 'xmtCustomerLegalObligation',
  CUSTOMERLAW = 'xmtCustomerLegal',
  CUSTOMERMODULE = 'xmtCustomerModule',
  DAMAGEKIND = 'xmtDamageKindLibrary',
  DAMAGEKINDLIBRARY = 'xmtDamageKindLibrary',
  DEPARTMENT = 'Department',
  DELEGATIONLETTER = 'xmtDelegationLetter',
  DELEGATIONLETTEROBLIGATION = 'xmtDelegationLetterObligation',
  DOCUMENT = 'Document',
  EVENT = 'xmtSubProjectEvent',
  LEGAL = 'xmtLegal',
  LEGALBASIS = 'xmtLegalBasis',
  LEGALBASISLIBRARY = 'xmtLegalBasisLibrary',
  LEGALDOMAIN = 'xmtLegalDomain',
  LEGALHISTORY = 'xmtLegalHistory',
  LEGALOBLIGATION = 'xmtLegalObligation',
  LEGALOBLIGATIONHISTORY = 'xmtLegalObligationHistory',
  LEGALSUBJECT = 'xmtLegalSubject',
  MAILADDRESS = 'MailAddress',
  MEASURE = 'xmtMeasure',
  MEASUREBENEFIT = 'xmtMeasureBenefit',
  MEASUREBENEFITLIBRARY = 'xmtMeasureBenefitLibrary',
  MEASUREDEFINITION = 'xmtMeasureDefinition',
  MEASUREDEFINITIONLIBRARY = 'xmtMeasureDefinitionLibrary',
  MEASUREPROGRESS = 'xmtMeasureProgress',
  MEASURERESOURCE = 'xmtMeasureResource',
  MEASURETAG = 'xmtMeasureTag',
  MEASURETYPE = 'xmtMeasureType',
  MODULE = 'xmtModule',
  PERSON = 'Person',
  PERSONDEPARTMENT = 'PersonDepartment',
  PHONENUMBER = 'PhoneNumber',
  PICKLIST = 'Picklist',
  PICKLISTITEM = 'PicklistItem',
  POSTING = 'Posting',
  PRODUCT = 'xmtRiskIssueProduct',
  PRODUCTLIBRARY = 'xmtProductLibrary',
  PROJECT = 'xmtProject',
  PROPERTY = 'Property',
  REMINDER = 'Reminder',
  REPORT = 'xmtReport',
  REPORTADDRESS = 'ReportPublishedToAddress',
  REPORTPERSON = 'ReportPerson',
  RESPONSIBLEPLAN = 'xmtResponsiblePlan',
  RISK = 'xmtRiskIssueTag',
  RISKASSESMENTMEASURE = 'xmtRiskAssessmentMeasure',
  RISKDAMAGEKIND = 'xmtRiskIssueDamageKind',
  RISKISSUE = 'xmtRiskIssue',
  RISKISSUETAG = 'xmtRiskIssueTag',
  STANDARD = 'xmtRiskIssueStandard',
  STANDARDLIBRARY = 'xmtStandardLibrary',
  STAFFMEMBER = 'xmtStaffMember',
  SUBMODULE = 'xmtSubModule',
  SUBPROJECT = 'xmtSubProject',
  TAG = 'xmtMeasureTag',
  TAGLIBRARY = 'xmtTagLibrary',
  TASK = 'xmtMeasureTask',
  TASKDEPENDENCY = 'TaskDependency',
  TASKPERSON = 'TaskPerson',
  TEAM = 'Team',
  TEAMMEMBER = 'TeamMember',
  TEAMPERSON = 'TeamPerson',
  WEBADDRESS = 'WebAddress',
  USERROLEPERMISSION = 'xmtUserRolePermission',
}
